import { render, staticRenderFns } from "./SchoolAutoConfigDialog.vue?vue&type=template&id=52968d90&scoped=true"
import script from "./SchoolAutoConfigDialog.vue?vue&type=script&lang=js"
export * from "./SchoolAutoConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./SchoolAutoConfigDialog.vue?vue&type=style&index=0&id=52968d90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52968d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52968d90')) {
      api.createRecord('52968d90', component.options)
    } else {
      api.reload('52968d90', component.options)
    }
    module.hot.accept("./SchoolAutoConfigDialog.vue?vue&type=template&id=52968d90&scoped=true", function () {
      api.rerender('52968d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SchoolAutoConfigDialog.vue"
export default component.exports